<div class="modal fade show d-block" tabindex="-1" style="background: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-center p-4">
      <h5 class="mb-3 fw-bold">Concluir tarefa</h5>
      <p>Tem certeza que deseja marcar esta tarefa como concluída?</p>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <button class="btn btn-secondary" (click)="fecharModal()"  type="button">Cancelar</button>
        <button class="btn btn-confirmar" (click)="confirmarConclusao()"  type="button">Confirmar</button>
      </div>
    </div>
  </div>
</div>
